import script from "./CardComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CardComponent.vue?vue&type=script&setup=true&lang=js"

import "./CardComponent.vue?vue&type=style&index=0&id=1196569d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1196569d"]])

export default __exports__